<template>
  <div class="wrapper">
    <page-header :title="header.title" :add-button="header.addButton" />
    <filters />
    <inner-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
    />
  </div>
</template>
<script>
import InnerList from './InnerList'
import Filters from './Filters'
import { Student } from '@/api'
import PaginatedList from '@/components/layout/PaginatedList'

export default {
  extends: PaginatedList,
  components: {
    InnerList,
    Filters
  },
  data() {
    return {
      service: Student
    }
  },
  computed: {
    header() {
      let title = `Lista kursantów`
      if (this.pagination.total) {
        title = `${title} <sup>(${this.pagination.total})</sup>`
      }
      return {
        addButton: {
          label: 'Dodaj kursanta',
          route: {
            path: '/admin/dodaj-kursanta/'
          }
        },
        title
      }
    }
  }
}
</script>
